// @vendors
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @actions
const actionTypes = require('constants/actionTypes');
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const brokerIntervenerActions = require('actions/brokerInterveners');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

// @utils
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME } } = require('commonsConstants/dateFormatTypes');
const { getConfirmationPDFSharesAmount } = require('utilities/pdfDocumentsHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    EURO_TEXT,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_ID,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ETF_BUY_BUYFOR_AMOUNT,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    BROKER_ORDER_TYPE_BUY,
    BROKER_PRODUCT_TYPE_ETFS_ES,
    CHARGE_ACCOUNT_PREFIX,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_ALERT_BUY_BUTTON_ETF,
    BROKER_MIFID_VERSION_2,
    INTERVENER_TYPE_PROPIETARIO,
    BROKER_HOLIDAY_VALIDATION_ERROR,
    BROKER_MIFID_ETF_PDF_AMOUNT_DECIMALS,
    API_CHANNEL
} = require('constants/index');

function reset() {
    return {
        type: actionTypes.BROKER_ETF_BUY_RESET
    };
}

function stockContractChanged(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_STOCK_CONTRACT_CHANGED,
        payload: {
            value
        }
    }
}

function validityDateChanged(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    }
}

function buyForOptionChanged(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_BUYFOR_OPTION_CHANGED,
        payload: {
            value
        }
    }
}

function buyForValueChanged(value, titleQuantity) {
    return {
        type: actionTypes.BROKER_ETF_BUY_BUYFOR_VALUE_CHANGED,
        payload: {
            value,
            titleQuantity
        }
    }
}

function buyForValueReset(initialPrice, productPrice) {
    return {
        type: actionTypes.BROKER_ETF_BUY_BUYFOR_VALUE_RESET,
        payload: {
            value: initialPrice,
            productPrice: productPrice
        }
    }
}

function orderTypeOptionChanged(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_ORDER_TYPE_OPTION_CHANGED,
        payload: {
            value
        }
    }
}

function orderTypeValueChanged(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_ORDER_TYPE_VALUE_CHANGED,
        payload: {
            value
        }
    }
}

function orderTypeValueReset(productPrice) {
    return {
        type: actionTypes.BROKER_ETF_BUY_ORDER_TYPE_VALUE_RESET,
        payload: {
            value: '',
            productPrice: productPrice
        }
    }
}

function mifidClauseChanged() {
    return {
        type: actionTypes.BROKER_ETF_BUY_MIFID_CLAUSE_CHANGED
    }
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_ETF_BUY_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    }
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_ETF_BUY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_ETF_BUY_WILL_CANCEL,
        payload: {
            value
        }
    }
}

function validateUIStep(step) {
    return {
        type: actionTypes.BROKER_ETF_BUY_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function validationSuccess(response) {
    return {
        type: actionTypes.BROKER_ETF_BUY_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    }
}

function validationFailure(response) {
    return {
        type: actionTypes.BROKER_ETF_BUY_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    }
}

function validationRequest() {
    return {
        type: actionTypes.BROKER_ETF_BUY_VALIDATE_REQUEST
    }
}

function confirmationSuccess(response) {
    return {
        type: actionTypes.BROKER_ETF_BUY_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    }
}

function confirmationFailure(response) {
    return {
        type: actionTypes.BROKER_ETF_BUY_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    }
}

function confirmationRequest() {
    return {
        type: actionTypes.BROKER_ETF_BUY_CONFIRM_REQUEST
    }
}

function etfsBuyDocumentStorageRequest() {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_STORAGE_REQUEST
    }
}

function etfsBuyDocumentStorageSuccess() {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_STORAGE_SUCCESS
    };
}

function etfsBuyDocumentStorageError() {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_STORAGE_ERROR
    };
}

function etfBuyFinish(response) {
    return {
        type: actionTypes.BROKER_ETF_BUY_FINISH,
        payload: {
            data: get(response, 'timestamp', '')
        }
    }
}

function extantCostRequest() {
    return {
        type: actionTypes.BROKER_ETF_EXTANTCOST_FECHING,
    };
}

function extantCostSuccess(data) {
    return {
        type: actionTypes.BROKER_ETF_EXTANTCOST_SUCESS,
        payload: data
    };
}

function extantCostError(error) {
    return {
        type: actionTypes.BROKER_ETF_EXTANTCOST_ERROR,
        payload: error
    };
}

const getExtantCostBuyETF = (history) => (dispatch, getState) => {
    const immStepOne = getState()['brokerETFBuy'].getIn(['steps', FIRST_STEP])
    const immOrderType = immStepOne.getIn(['orderTypeOption']);
    let orderType = '';
    let limitedPrice = null;
    let sharesAmount = null;
    let sharesNumber = null;

    const buyForOption = immStepOne.getIn(['buyForOption']);

    if (buyForOption === "amount") {
        sharesAmount = {
            amount: immStepOne.getIn(['buyForValue']),
            currency: getState().brokerProductFile.get('currency'),
            descriptionKey: null,
            percentage: null,
            tooltipKey: null,
            type: null
        }
    } else if (buyForOption === 'titles') {
        sharesNumber = immStepOne.getIn(['titleQuantity']);
    }

    switch (immOrderType) {
        case 'toMarket':
            orderType = 'MARKET';
            break;
        case 'forTheBest':
            orderType = 'BEST';
            break;
        case 'limited':
            orderType = 'LIMITED';
            limitedPrice = {
                amount: immStepOne.getIn(['orderTypeValue']),
                currency: getState().brokerProductFile.get('currency'),
                descriptionKey: null,
                percentage: null,
                tooltipKey: null,
                type: null
            }
            break;
    }

    const selectedOption = immStepOne.getIn(['stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.get(selectedOption);

    const data = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: contract.get('walletNumber'),
            product: contract.get('productNumber')
        },
        instrumentType: 'ETF',
        isin: getState().brokerProductFile.get('isinCode'),
        limitedPrice,
        market: getState().brokerProductFile.get('micCode'),
        operationType: 'C',
        orderType,
        sharesAmount,
        sharesNumber
    }

    dispatch(extantCostRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), { query: data }).then(
        function (response) {
            dispatch(extantCostSuccess(response));
        },
        function (error) {
            const errorKey = get(error, ['body', 'error'], '') || error.error;
            dispatch(extantCostError(error));
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
}

function getValidationData(getState) {
    const operationFirstStep = getState()['brokerETFBuy'].getIn(['steps', FIRST_STEP]);

    const validationData = {
        'descripcionRestriccion': BROKER_STOCKS_BUY_NO_RESTRICTION,
        'tipoNegociacion': '0',
        'tipoRestriccion': '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const orderType = operationFirstStep.get('orderTypeOption');
    const validityDate = operationFirstStep.get('validityDate');
    const buyFor = operationFirstStep.get('buyForOption');

    if (buyFor === BROKER_ETF_BUY_BUYFOR_AMOUNT) {
        validationData['importeAprximado'] = {
            'divisa': EURO_TEXT,
            'importe': operationFirstStep.get('buyForValue')
        };
        if (getState().brokerETFBuy.getIn(['confirmationData'])) {
            validationData['numTitulos'] = getState().brokerETFBuy.getIn(['confirmationData']).titulosImporteAproximado
        }
    } else {
        validationData['numTitulos'] = operationFirstStep.get('titleQuantity');
    }

    const currency = getState().brokerProductFile.get('currency');

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            'divisa': currency,
            'numeroimportevalores': operationFirstStep.get('orderTypeValue')
        };
    } else {
        validationData['importeLimitada'] = {
            'divisa': currency,
            'numeroimportevalores': 0
        };
    }

    validationData['tipoOrden'] = orderTypes[orderType].code;
    validationData['descripcionOrden'] = orderTypes[orderType].orderDescription;
    validationData['plazoValidez'] = validityDate.format('YYYY-MM-DD');

    return validationData;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
            ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
            : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const storeDocument = (response) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immETFs = getState().brokerETFBuy;
    const immBrokerProductFile = getState().brokerProductFile;
    const immFeatureFlags = getState().flagBasedFeatures;
    const showExantCostETFBuy = immFeatureFlags.get('wealth_etfs_buy_show_costs')
    const immBrokerETFBuy = getState().brokerETFBuy;
    const dataValidation = getValidationData(getState);
    const immETFsBuyStep1 = immETFs.getIn(['steps', FIRST_STEP]);
    const validityDate = immETFsBuyStep1.get('validityDate').format('YYYY-MM-DD');
    const selectedContractValue = immETFsBuyStep1.get('stocksContractSelectedValue');
    const conditionPrize = immETFsBuyStep1.get('orderTypeOption') === BROKER_ORDER_TYPE_LIMITED ? immETFsBuyStep1.get('orderTypeValue') : '';
    const contract = getState().brokerStocksContract.get(selectedContractValue);
    const titleQuantity = parseFloat(immETFs.getIn(['steps', 0, 'titleQuantity']));
    const contactNumber = contract.get('contactNumber');
    const productNumber = contract.get('productNumber');
    const controlDigit = contract.get('controlDigit');
    const currency = contract.getIn(['walletBalance', 'currency']);
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contactNumber}`;
    const marketName = showExantCostETFBuy
        ? immBrokerProductFile.get("micCode")
        : getState().brokerProductFile.get("marketName");
    const productAmount = Number(immBrokerProductFile.getIn(['productValue', 'amount'])) || 0;
    const isLimitedOrder = immBrokerETFBuy.getIn(['steps', FIRST_STEP, 'orderTypeOption']) === BROKER_ORDER_TYPE_LIMITED;
    const isBuyForAmountOrder = immBrokerETFBuy.getIn(['steps', FIRST_STEP, 'buyForOption']) === BROKER_ETF_BUY_BUYFOR_AMOUNT;
    const amountInput = immBrokerETFBuy.getIn(['steps', FIRST_STEP, 'buyForValue']);
    const dataExtant = getState().brokerETFBuy.getIn(['exAnteCostsList']);
    const sharesAmount = !!dataExtant && !!dataExtant.get('estimatedBaseAmount')
        ? dataExtant.getIn(['estimatedBaseAmount', 'amount'])
        : getConfirmationPDFSharesAmount({
            isLimitedOrder,
            isBuyForAmountOrder,
            amountInput,
            sharesNumber: titleQuantity,
            lastPrice: productAmount,
            decimals: BROKER_MIFID_ETF_PDF_AMOUNT_DECIMALS
        });
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const dfiURL = getState().brokerETFBuy.get('dfiUrl');
    const exantCostsData = !!dataExtant.getIn(["exAnteCostList"])
        ? translateExantCostKey(dataExtant.getIn(["exAnteCostList"]).toJS(), 'brokerETFBuy')
        : null;

    const communicationServiceInput = {
        "email": PersonalDataHelper.getEmail(immProfile),
        "productKID": dfiURL,
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "saveDocumentation": "yes",
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": getState().brokerProductFile.get('isinCode'),
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "idOrder": get(response, 'numeroOrden', ''),
        "channel": CONNECTION_CHANNEL_INTERNET,
        "orderType": BROKER_ORDER_TYPE_BUY,
        "productType": BROKER_PRODUCT_TYPE_ETFS_ES,
        "holders": holderNames.join(','),
        "ccv": securityAccount,
        "idContract": securityAccount,
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], '').trim(),
        "market": marketName,
        "sharesNumber": "" + titleQuantity,
        "orderCondition": dataValidation.descripcionOrden,
        "sharesAmount": "" + sharesAmount,
        "termValidity": validityDate,
        "conditionPrize": "" + conditionPrize + "",
        "currency": currency,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    let requestData;
    if (showExantCostETFBuy) {
        requestData = {
            query: {
                ...communicationServiceInput,
                exAnteCostsList: exantCostsData
            }
        };
    } else {
        requestData = {
            query: communicationServiceInput
        };
    }

    dispatch(etfsBuyDocumentStorageRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData).then(
        function () {
            dispatch(etfsBuyDocumentStorageSuccess());
        },
        function () {
            dispatch(etfsBuyDocumentStorageError());
        }
    );
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
                .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
                .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            let disclaimerText;
            if (index === 0 && !!get(disclaimer, 'phrase')) {
                disclaimerText = `${trim(get(disclaimer, 'description'))} ${get(disclaimer, 'phrase')}`
            } else {
                disclaimerText = trim(get(disclaimer, 'description'));
            }

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const confirmETFsBuy = (history) => (dispatch, getState) => {
    const ETFState = getState()['brokerETFBuy'];
    const operationSecondStep = ETFState.getIn(['steps', SECOND_STEP]);
    const hasSignaturePattern = operationSecondStep.get('hasSignaturePattern');
    const valid = operationSecondStep.get('valid');
    if (!valid || !hasSignaturePattern) {
        return;
    }

    const operationFirstStep = ETFState.getIn(['steps', FIRST_STEP]);
    const dataToken = ETFState.get('token');
    const confirmationData = ETFState.get('confirmationData');
    const executionData = confirmationData.datosEjecucion;
    const emitData = confirmationData.datosEmision;
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const isSpain = isinCode.substr(0, 2).toLowerCase() === 'es';
    const shares = get(confirmationData, 'titulosImporteAproximado');
    const productId = immBrokerProductFile.get('isComplex') ? BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID : BROKER_CONVENIENCE_MIFID_TEST_ETF_ID;
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', productId, 'codigoDisclaimer']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const data = {
        'contratoValores': {
            'numerodecontrato': contract.get('walletNumber'),
            'producto': contract.get('productNumber')
        },
        'dataToken': dataToken,
        'datosEjecucion': {
            'codigoGrupoSector': executionData.codigoGrupoSector,
            'codigoOrganismoEjecucion': executionData.codigoOrganismoEjecucion,
            'codigoValorJuntSind': executionData.codigoValorJuntSind,
            'codvalorSib': executionData.codvalorSib,
            'indicadorCompensacion': executionData.indicadorCompensacion,
            'indicadorContingencia': executionData.indicadorContingencia,
            'indicadorEnvioRecepcion': executionData.indicadorEnvioRecepcion,
            'nominalTitulo': {
                'divisa': executionData.nominalTitulo.divisa,
                'importe': executionData.nominalTitulo.importe
            },
            'tipoCotizacion': executionData.tipoCotizacion,
            'tipoMercado': executionData.tipoMercado,
            'tipoOperacion': 'C',
            'titulosNominalMinEjec': 0,
            'tratamientoEmision': executionData.tratamientoEmision
        },
        'datosEmision': {
            'codEmision': emitData.codEmision,
            'codMercado': emitData.codMercado,
            'codValor': emitData.codValor
        },
        'datosValidacion': getValidationData(getState),
        "convenienceTest": codigoDisclaimer,
        "productIsin": isinCode,
        "productType": BROKER_ALERT_BUY_BUTTON_ETF,
        "shares": shares,
        "initQuantity": shares,
        "unitPrice": immBrokerProductFile.get('lastClose'),
        "productManager": immBrokerProductFile.get('manager'),
        "micCode": micCode,
        "convenientRegistry": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
        "evaluateRegistry": mifidWasApplied,
        "disclaimers": mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
        "marketTargetRegistry": mifidScore >= mifidScoring,
        "necessaryConvenienceTestNote": mifidScoring,
        "necessaryTargetMarketNote": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
        "testConveniencyResult": mifidScore,
        "documentationId": uuid
    };

    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        header: {
            version: 2
        },
        query: data
    };

    dispatch(confirmationRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData)
        .then(function (response) {
            dispatch(confirmationSuccess(response));
            dispatch(etfBuyFinish(response));
            dispatch(storeDocument(response));
            dispatch(outdateGlobalPosition());
            dispatch(outdateMyInvestments());
        }, function (response) {
            dispatch(confirmationFailure(response));
            dispatch(brokerStocksOperationFailure(response, history));
        }
        );
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmETFsBuy(history)); //Calling actions in sync to use the data token in confirmETFsBuy
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const getInterveners = () => (dispatch, getState) => {

    const operationFirstStep = getState()['brokerETFBuy'].getIn(['steps', FIRST_STEP]);
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);

    const wallet = Immutable.fromJS({
        accountNumber: contract.get('walletNumber'),
        product: contract.get('productNumber')
    })
    dispatch(brokerIntervenerActions.getIndexes(wallet));
}
const validateWithAPI = (history) => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerETFBuy'].getIn(['steps', FIRST_STEP]);
    const valid = operationFirstStep.get('valid');
    const validSecondStep = getState()['brokerETFBuy'].getIn(['steps', SECOND_STEP, 'valid']);
    const secondStepShouldValidate = getState()['brokerETFBuy'].getIn(['steps', SECOND_STEP, 'shouldValidate']);

    if (valid && validSecondStep) {
        dispatch(finish(history));
        return;
    } else if (!valid || !secondStepShouldValidate) {
        return;
    }

    let requestData, data;

    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const isinCode = getState().brokerProductFile.get('isinCode');
    const micCode = getState().brokerProductFile.get('micCode');
    const contract = getState().brokerStocksContract.get(selectedOption);

    requestData = {
        'codigoISIN': isinCode,
        'codigoISO': micCode,
        'contratoValores': {
            'numerodecontrato': contract.get('walletNumber'),
            'producto': contract.get('productNumber')
        },
        'datosValidacion': getValidationData(getState),
        'digitoControl': contract.get('controlDigit'),
        'discriminadorClausula': 'N',
        'tipoOperacion': 'C'
    };

    data = {
        query: requestData
    }

    dispatch(validationRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('stocksSimpleBuyValidation'), data)
        .then(function (response) {
            dispatch(validationSuccess(response));
            dispatch(getInterveners());
        }, function (response) {
            dispatch(validationFailure(response));
            const errorKey = get(response, ['body', 'error'], '') || response.error;
            if (errorKey !== BROKER_HOLIDAY_VALIDATION_ERROR) {
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        }
        );
};

function setHolidayError() {
    return {
        type: actionTypes.BROKER_ETF_BUY_SET_HOLIDAY_ERROR
    };
}

const validateStep = (step, history) => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateWithAPI(history));
};

function requestDFIFetching() {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_DFI_FETCHING
    };
}
function requestDFISuccess(url) {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_DFI_SUCCESS,
        payload: {
            DIFUrl: url
        }
    };
}
function requestDFIFailure() {
    return {
        type: actionTypes.BROKER_ETF_BUY_DOCUMENT_DFI_ERROR
    };
}

const getDFI = isin => dispatch => {
    const requestData = {
        query: {
            productType: "ETF",
            documentType: "pdf",
        },
    };
    dispatch(requestDFIFetching());
    APIGet(
        dispatch,
        apiURLBuilder.getURL("etfsDocuments", { isin }),
        requestData
    ).then(response => {
        if (!!response.documents) {
            const url = response.documents.find((doc) => {
                return doc.documentKey === "DFI";
            }).documentUrl;
            if (!!url) {
                dispatch(requestDFISuccess(url));
            } else {
                dispatch(requestDFIFailure());
            }
        } else {
            dispatch(requestDFIFailure());
        }
    })
        .catch(() => dispatch(requestDFIFailure()));
};

function toggleDocumentsCheckboxAction() {
    return {
        type: actionTypes.BROKER_ETF_BUY_TOGGLE_DOCUMENTS_CHECKBOX,
    }
}

const toggleDocumentsCheckbox = () => dispatch => {
    dispatch(toggleDocumentsCheckboxAction());
}

function toggleRiskCheckboxAction() {
    return {
        type: actionTypes.BROKER_ETF_BUY_TOGGLE_RISK_CHECKBOX,
    }
}

const toggleRiskCheckbox = () => dispatch => {
    dispatch(toggleRiskCheckboxAction());
}

function resetCheckboxAction() {
    return {
        type: actionTypes.BROKER_ETF_BUY_RESET_CHECKBOX,
    }
}

const resetCheckbox = () => dispatch => {
    dispatch(resetCheckboxAction())
}

module.exports = {
    reset,
    setVisibleStep,

    validateStep,

    finish,
    stockContractChanged,
    validityDateChanged,
    buyForOptionChanged,
    buyForValueChanged,
    buyForValueReset,
    orderTypeOptionChanged,
    orderTypeValueChanged,
    orderTypeValueReset,
    mifidClauseChanged,
    setWillCancel,
    setHolidayError,
    getDFI,
    toggleDocumentsCheckbox,
    toggleRiskCheckbox,
    resetCheckbox,
    getExtantCostBuyETF
};

